export class HttpError extends Error {
  constructor(
    public statusCode: number,
    message: string,
    public details?: unknown,
  ) {
    super(message);
    this.name = 'HttpError';
  }

  static isHttpError(error: unknown): error is HttpError {
    return error instanceof HttpError;
  }

  static isForbidden(error: unknown): boolean {
    return HttpError.isHttpError(error) && error.statusCode === 403;
  }

  static isUnauthorized(error: unknown): boolean {
    return HttpError.isHttpError(error) && error.statusCode === 401;
  }

  static isNotFound(error: unknown): boolean {
    return HttpError.isHttpError(error) && error.statusCode === 404;
  }
}
